import { getBusinesses, getRandomBusiness } from '../api/businesses';
import * as React from 'react';
import { BusinessesView } from '../components/BusinessesView';
export var BusinessesContainer = function () {
    var _a = getBusinesses(), isAllBusinessesLoading = _a.isLoading, businessesError = _a.error, businesses = _a.data;
    var _b = getRandomBusiness(), isRandomBusinessLoading = _b.isLoading, businessError = _b.error, randomBusiness = _b.data;
    return (React.createElement(BusinessesView, { businesses: {
            isLoading: isAllBusinessesLoading,
            error: businessesError,
            data: businesses,
        }, randomBusiness: {
            isLoading: isRandomBusinessLoading,
            error: businessError,
            data: randomBusiness,
        } }));
};
